import React from 'react'
import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  ImgWrapper,
  Img
} from './InfoSection.elements'
import { Container, Button } from '../../globalStyles'

const InfoSection = ({
  primary,
  lightBg,
  topLine,
  lightTopLine,
  lightText,
  lightTextDesc,
  headline,
  description,
  buttonLabel,
  img,
  alt,
  imgStart,
  start
}) => {
  return (
    <InfoSec lightBg={lightBg}>
      <Container>
        <InfoRow>
          <InfoColumn $imgStart={imgStart}>
            <TextWrapper>
              {topLine && <TopLine lightTopLine={lightTopLine}>{topLine}</TopLine>}
              <Heading lightText={lightText}>{headline}</Heading>
              <Subtitle lightTextDesc={lightTextDesc}>{description}</Subtitle>

              <Button
                as="button"
                type="button"
                big
                fontBig
                primary={primary}
                onClick={() => {
                  const el = document.getElementById("pricing");

                  if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                  }
                }}
              >
                {buttonLabel}
              </Button>
            </TextWrapper>
          </InfoColumn>

          <InfoColumn $isImage $imgStart={imgStart} $start={start}>
            <ImgWrapper>
              <Img src={img} alt={alt} />
            </ImgWrapper>
          </InfoColumn>
        </InfoRow>
      </Container>
    </InfoSec>
  )
}

export default InfoSection
